import React from 'react'
import Header from '../../common/Header'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import CommonHeroSection from '../../common/CommonHeroSection'
import Footer from '../../common/Footer'
import TicketSection from '../../sections/CommonSection/TicketSection'
import busTicketBookingImg from '../../../assets/our-services-img/bus-booking-img.jpg';

const BusTicketBooking = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title={"Bus Ticket Booking "} />
            <CommonBreadcrumb items={["Bus Ticket Booking"]} />
            <TicketSection
                title="Bus Ticket Booking"
                description={[
                    `Though there are miscellaneous options of transportation like flights, cars and many others available for travelling to a place, nothing can beat the rhythmic and less-costly journey of a train. When it's about booking a railway ticket, Sudarshan Holidays is the one-stop solution. Railway ticket booking can be time-consuming if every single detail is not filled with proper information and care.`,

                    `We are one of the trustworthy travel agencies on which you can rely with 100% trust. At Sudarshan Holidays, we both efficiently book your railway tickets and deliver them to your address with a rapid and assured delivery before your much-awaited Bangalore trip.`,

                    `Mail your legal documents to us or call us to get assured bookings of your required railway tickets.`,
                ]}
                image={busTicketBookingImg}
            />
            <Footer />
        </>
    )
}

export default BusTicketBooking